import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "name", "form", "input", "error"]
  static values = { url: String }

  edit(event) {
    event.preventDefault()
    event.stopPropagation()
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget.value = this.nameTarget.textContent.trim()
    this.inputTarget.focus()
    this.inputTarget.select()
    this.hideError()
  }

  cancel(event) {
    event.preventDefault()
    event.stopPropagation()
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    this.hideError()
  }

  async save(event) {
    event.preventDefault()
    event.stopPropagation()

    const newName = this.inputTarget.value.trim()
    if (!newName) {
      this.showError("Name can't be blank")
      return
    }
    if (newName === this.nameTarget.textContent.trim()) {
      this.cancel(event)
      return
    }

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ audio_mix: { name: newName } })
      })

      if (response.ok) {
        this.nameTarget.textContent = newName
        this.formTarget.classList.add("hidden")
        this.displayTarget.classList.remove("hidden")
        this.hideError()
      } else {
        this.showError("Couldn't save — try again")
      }
    } catch (error) {
      console.error("Rename failed:", error)
      this.showError("Couldn't save — try again")
    }
  }

  keydown(event) {
    if (event.key === "Escape") this.cancel(event)
    if (event.key === "Enter") this.save(event)
  }

  showError(msg) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = msg
      this.errorTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }
}
